import React, { useState } from 'react'
import { Box, Chip, Collapse, IconButton, TableCell, TableRow, Typography } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { formatNumber } from 'src/common/helpers'
import { EligibleWallet } from 'src/common/api'
import SnapshotTable from './SnapshotTable'

const WalletRow: React.FC<{ wallet: EligibleWallet }> = ({ wallet }) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <TableRow hover>
        <TableCell>
          <Box display="flex" alignItems="center" gap={0.5}>
            <IconButton size="small" onClick={() => setOpen(!open)} aria-label="toggle snapshots">
              {open ? <KeyboardArrowUpIcon fontSize="small" /> : <KeyboardArrowDownIcon fontSize="small" />}
            </IconButton>
            <Typography sx={{ fontWeight: 600, fontSize: 13 }}>{wallet.address}</Typography>
          </Box>
          <Box display="flex" alignItems="center" gap={1} pl={4.5}>
            {/* Wallet addresses are shown in full and never truncated. */}
            <Typography sx={{ fontFamily: 'monospace', fontSize: 12, color: 'text.secondary', wordBreak: 'break-all' }}>
              {wallet.name}
            </Typography>
            <Chip label={wallet.chain} size="small" sx={{ height: 18, fontSize: 10, fontWeight: 700 }} />
            {wallet.previouslyEligible && (
              <Chip
                label="Previously Eligible"
                size="small"
                sx={{ height: 18, fontSize: 10, fontWeight: 700, backgroundColor: '#fef3c7', color: '#92400e' }}
              />
            )}
          </Box>
        </TableCell>
        <TableCell align="center">
          <Chip
            label={wallet.walletType === 'TREASURY' ? 'Treasury' : 'Minting'}
            size="small"
            color="primary"
            variant="outlined"
          />
        </TableCell>
        <TableCell align="center">
          <Box display="inline-flex" alignItems="center" gap={1}>
            <Typography component="span" sx={{ fontFamily: 'monospace', fontWeight: 600 }}>
              {wallet.daysEligible}/{wallet.periodDays}
            </Typography>
            {wallet.prorated && (
              <Chip
                label="Prorated"
                size="small"
                sx={{ height: 20, fontSize: 11, backgroundColor: '#fef3c7', color: '#92400e' }}
              />
            )}
          </Box>
        </TableCell>

        <TableCell align="right" sx={{ fontFamily: 'monospace', fontWeight: 600, color: 'primary.main' }}>
          {formatNumber(wallet.grossAccrualQcad)}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell colSpan={5} sx={{ p: 0, border: open ? undefined : 'none' }}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <SnapshotTable snapshots={wallet.snapshots} />
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  )
}

export default WalletRow
